import { withMask } from "use-mask-input";
import { validateGallbladderDate } from "@/utils/validateField/gallbladder";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { useManageInputFields } from "@/pages/quiz/hooks/useManageInputFields";
import { Button } from "@/pages/quiz/15000/components/Button";
import { Input } from "@/pages/quiz/15000/components/Input";

type FormFieldName = "date";
type ContactFieldsValues = Record<FormFieldName, string>;

const validationFields = {
  date: {
    customValidator: validateGallbladderDate,
    required: true,
  },
};

const CustomGallbladderDate = ({
  questionValue,
  setQuestionValue,
  setQuestionAnswer,
}: QuizQuestionProps<ContactFieldsValues>) => {
  const { registerField, onValidateForm, error } = useManageInputFields(
    {
      setQuestionValue,
      questionValue,
    },
    validationFields
  );

  const isNoErrors = Object.values(error).every(
    (errorMessage) => !errorMessage
  );

  const isAllAnswered =
    Object.values(questionValue).filter(Boolean).length === 1;

  const isFormAnswered = isAllAnswered && isNoErrors;

  const onSubmit = async () => {
    if (isFormAnswered) {
      setQuestionAnswer(questionValue);
    }
  };

  return (
    <>
      <Input
        {...registerField("date")}
        ref={withMask("99/99/9999", {
          jitMasking: true,
          showMaskOnHover: false,
        })}
        inputMode="numeric"
        pattern="[0-9]*"
        label="Date of surgery"
        placeholder="MM/DD/YYYY"
        errorMessage={error?.date}
      />

      <Button disabled={!isFormAnswered} onClick={onValidateForm(onSubmit)} />
    </>
  );
};

export { CustomGallbladderDate };
